import { NavLink } from "react-router-dom";

const tabs = [
  { label: "首页", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill", to: "/" },
  { label: "分类", icon: "ri-grid-line", activeIcon: "ri-grid-fill", to: "/category/movie" },
  { label: "搜索", icon: "ri-search-line", activeIcon: "ri-search-line", to: "/search" },
  { label: "收藏", icon: "ri-heart-line", activeIcon: "ri-heart-fill", to: "/favorites" },
  { label: "关于", icon: "ri-information-line", activeIcon: "ri-information-fill", to: "/about" },
];

export default function MobileTabBar() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-background-200 bg-background-50/95 backdrop-blur lg:hidden">
      <ul className="flex items-stretch">
        {tabs.map((tab) => (
          <li key={tab.to} className="flex-1">
            <NavLink
              to={tab.to}
              end={tab.to === "/"}
              className={({ isActive }) =>
                `flex h-16 flex-col items-center justify-center gap-1 text-[11px] transition-colors ${
                  isActive ? "text-primary-600" : "text-foreground-500"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <i className={`${isActive ? tab.activeIcon : tab.icon} text-2xl`}></i>
                  <span>{tab.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}